<template>
  <v-app class="main-container">
    <v-container fill-height>
      <v-row justify="center" align="center">
        <div>
          <router-view v-show="isServiceOk" :user="user" :appLogo="appLogo" :appTitle="appTitle" :sudirState="sudirState" />
          <AppLoading :isLoading="isServiceloading" />
          <Wrapper
              :appTitle="appTitle"
              :appLogo="appLogo"
            v-if="isServiceFailed"
            :authFormStyles="'auth__col-6'"
          >
            <v-alert
              class="mb-3 mt-6 box-alert"
              v-show="isServiceFailed"
              text
              prominent
              type="error"
            >
              Система временно недоступна. Пожалуйста, попробуйте выполнить вход
              позднее, или сообщите об ошибке в техническую поддержку.
            </v-alert>
          </Wrapper>
        </div>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { endpointUrl } from "../app.config";
import AppLoading from "./components/AppLoading";
import axios from "axios";
import Wrapper from "./components/Wrapper.vue";

export default {
  components: {
    AppLoading,
    Wrapper,
  },
  data: (vm) => {
    return {
      isServiceloading: true,
      isServiceOk: false,
      isServiceFailed: false,
      user: vm.$root.user,
      appLogo: "",
      appTitle: "",
      sudirState: 0
    };
  },
  computed: {
    areWeOnLoginPage() {
      return this.$router.currentRoute.name === "Login" || !this.user.logged;
    },
  },
  created() {
    let self = this;
    let heartbeatPromise = axios({
      url: endpointUrl + "heartbeat",
      method: "GET",
    });

    heartbeatPromise
      .then((res) => {
        if (res && res.data && res.data.status === "ok") {
          self.isServiceloading = false;
          self.isServiceOk = true;
          self.isServiceFailed = false;
          self.appLogo = res.data.logo;
          self.appTitle = res.data.title ? res.data.title : "Экспло";
          self.sudirState = res.data.sudirState;

          document.title = self.appTitle;
        } else {
          throw new Error("no valid data");
        }
      })
      .catch((e) => {
        console.log(e);
        self.isServiceloading = false;
        self.isServiceOk = false;
        self.isServiceFailed = true;
      });
  },
};
</script>


